import React from 'react'
import { useEffect } from 'react'
import prpBanner from './../../../../../assets/images/blogs/growhair1-31-07-2025.jpg';
import { useNavigate } from 'react-router-dom';
import favicon from "./../../../../../assets/images/favicon.ico"
import './growhair.css';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const Growhair = () => {

   const handleDownloadPdf = () => {
  const input = document.querySelector('.dentalblog'); // Use the main container class
  
  html2canvas(input, { 
    scale: 2,
    useCORS: true,
    logging: false 
  }).then((canvas) => {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const imgWidth = 210;
    const pageHeight = 297;
    const imgHeight = canvas.height * imgWidth / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }
    
    pdf.save('H-Cura_GrowHair_Treatment.pdf');
  }).catch(error => {
    console.error('Error generating PDF:', error);
    alert('Failed to generate PDF. Please try again.');
  });
};
     let navigate = useNavigate()
    
              useEffect(() => {
                   document.title = " GrowHair Therapy for Hair Fall Treatment & Regrowth | Best Hair Clinic in Bangalore & Chennai";
                   const metaDescription = document.querySelector("meta[name='description']");
                   if (metaDescription) {
                     metaDescription.setAttribute(
                       "content",
                       " Stop hair fall and promote natural regrowth with GrowHair Therapy – a non-surgical, protein-rich solution offered at H-Cura Hair Clinic in Bangalore and Chennai. Book expert consultation now!"
                     );
                   }
                   const metaKeywords = document.querySelector("meta[name='keywords']");
                   if (metaKeywords) {
                     metaKeywords.setAttribute(
                       "content",
                       "Hair fall treatment, Hair regrowth therapy, GrowHair Therapy, Hair thinning solution, Best hair clinic in Bangalore, Hair fall treatment in Chennai, Hair regrowth clinic, Hair loss solution, Non-surgical hair regrowth, Natural hair regrowth treatment, Hair specialist in Bangalore, Hair specialist in Chennai, Scalp therapy, Scalp care therapy, Safe hair treatment, Hair strengthening treatment, Protein-rich hair therapy, Sulfate-free shampoo, Hair fall solution reviews, Hair care consultation"
                     );
                   }
                    // Set canonical link
                    const existingCanonical = document.querySelector("link[rel='canonical']");
                    if (existingCanonical) {
                      existingCanonical.setAttribute("href", "https://www.h-cura.com/growhair-therapy-hair-fall-treatment");
                    } else {
                      const canonicalLink = document.createElement("link");
                      canonicalLink.setAttribute("rel", "canonical");
                      canonicalLink.setAttribute("href", "https://www.h-cura.com/growhair-therapy-hair-fall-treatment");
                      document.head.appendChild(canonicalLink);
                    }
                    // Set favicon
                 const existingFavicon = document.querySelector("link[rel='icon']");
                 if (existingFavicon) {
                   existingFavicon.setAttribute("href", favicon);
                 } else {
                   const faviconLink = document.createElement("link");
                   faviconLink.setAttribute("rel", "icon");
                   faviconLink.setAttribute("type", "image/x-icon");
                   faviconLink.setAttribute("href", favicon);
                   document.head.appendChild(faviconLink);
                 }
                 
                 }, []);
    
                 
    
         const handleBookAppointment = () => {
        navigate('/bookconsultation'); // Use navigate to redirect to the booking page
       };

// ...existing code...
useEffect(() => {
  // ...existing meta and favicon code...

  // FAQ accordion logic
  const faqItems = document.querySelectorAll('.blogfaqs-item');
  faqItems.forEach(item => {
    const question = item.querySelector('.blogfaqs-question');
    const answer = item.querySelector('.blogfaqs-answer');
    answer.style.maxHeight = '0px';
    question.onclick = () => {
      faqItems.forEach(otherItem => {
        if (otherItem !== item && otherItem.classList.contains('active')) {
          otherItem.classList.remove('active');
          otherItem.querySelector('.blogfaqs-answer').style.maxHeight = '0px';
        }
      });
      item.classList.toggle('active');
      if (item.classList.contains('active')) {
        answer.style.maxHeight = answer.scrollHeight + 'px';
      } else {
        answer.style.maxHeight = '0px';
      }
    };
  });
}, []);
// ...existing code...
  return (
   <>
   
  <div className="dentalblog">
      <div className="dentalblog-banner">
  <img src={prpBanner} alt="Dental Care Banner" />
  <div className="dentalblog-banner-overlay">
    <h1>GrowHair Therapy: Advanced Hair Fall Treatment</h1>
    <h2> That Delivers Visible Regrowth</h2>
    <button 
      className="dentalblogbook-appointment-btn" 
      onClick={handleBookAppointment}
    >
      Book Appointment
    </button>
  </div>
</div>

        
        <div className="dentalblog-container">
          <div className="dentalblog-intro">
            <p>Tired of seeing excessive strands on your pillow, comb, or shower drain? Hair fall can feel like a never-ending problem, but with the right solution, you can reverse it naturally. GrowHair Therapy is a medically advanced, non-surgical hair regrowth treatment designed to stop hair fall and stimulate new hair growth at the follicle level.</p>
            <p>
                At H-Cura Hair Regrowth Clinic, with branches in Jayanagar, Bangalore and Valasaravakkam & Gerugambakkam, Chennai, we bring you personalized, evidence-based solutions to combat hair loss — without surgery or side effects.</p>
          </div>
          
          <div className="dentalblog-section">
            <h2>✅ What Is GrowHair Therapy?</h2>
            <p>GrowHair Therapy is a cutting-edge, non-invasive procedure that combines scalp therapy, follicle rejuvenation, and nutrient infusions to tackle hair thinning and restore scalp health.</p>
            <p>This hair fall treatment works effectively for both men and women suffering from androgenetic alopecia, stress-induced hair fall, post-pregnancy hair loss, or nutritional deficiencies.</p>
          </div>
          
            <div className="dentalblog-section">
                 <h2>🔁 Home Hair Care Tips to Support Hair Regrowth</h2>
                  <div className="dentalblog-tips">
           
            <div className="dentalblog-tip-card">
              <h3>1️⃣ Clean Your Scalp Regularly</h3>
              <p>Use a sulfate-free shampoo to remove dirt and oil without irritating the scalp. This prevents follicle blockage and supports hair fall control.</p>
             
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>2️⃣  Eat Hair-Nourishing Foods</h3>
              <p>A protein-rich diet with iron, zinc, and biotin is essential. Include eggs, spinach, almonds, fish, and seeds.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>3️⃣ Stay Hydrated & Stress-Free</h3>
              <p>Chronic stress is a major cause of hair fall. Practice yoga, meditation, or breathing exercises to support hair health.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>4️⃣ Avoid Heat Styling & Chemical Treatments</h3>
              <p>High heat and harsh chemicals weaken hair strands. Always use a heat protectant and minimize coloring or straightening.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>5️⃣ Moisturize Your Scalp</h3>
              <p>Use lightweight oils or scalp-safe serums to maintain hydration and improve elasticity.</p>
              
            </div>
            
           
          </div>
                </div>
         
          
          <div className="dentalblog-cta">
            <h2>📞 Book Your Appointment Now</h2>
            <p>👉 Call: <a href="tel:+918870001377">+91 88700 01377</a></p>
            <p>📍 Visit us in Bangalore (Jayanagar) or Chennai (Tambaram , Gerugambakkam & Valasaravakkam)</p>
          </div>
          
        
          
          <div className="dentalblog-testimonials">
            <h2> ✅ GrowHair Therapy – Results You Can See</h2>
            <p>💬 "After 2 GrowHair sessions at H-Cura in Bangalore, my hair fall reduced dramatically. I’m seeing new hair growth already!" – Anuj R.</p>
            <div className="testimonial-container">
              <div className="testimonial">
                <p>💬 "My confidence was shattered due to thinning hair. H-Cura’s GrowHair Therapy brought it back." – Raghav S.</p>
              </div>
              <div className="testimonial">
                <p>💬 "The best hair clinic in Chennai! Their scalp therapy was life-changing." – Priya M.</p>
              </div>
            </div>
          </div>
            <div className="dentalblog-summary">
            <h2>📍 GrowHair Therapy Locations in South India</h2>
            <ul>
              <li>📌 Bangalore – Jayanagar: Best Hair Clinic for non-surgical hair fall treatment</li>
              <li>📌 Chennai – Valasaravakkam: Specialist in natural hair regrowth treatment</li>
              <li> 📌 Chennai – Gerugambakkam: Known for hair strengthening and scalp care therapy</li>
            
            </ul>
           
          </div>
        </div>
      </div>

   <div className="blogfaqs">
   <div className="blogheading faq-heading">
  <h2>Frequently Asked Questions</h2>
  <div className="faq-underline"></div>
</div>
  <div className="blogfaqs-item">
    <div className="blogfaqs-question">
      How long before I see results with GrowHair Therapy?
      <span className="blogfaqs-icon"></span>
    </div>
    <div className="blogfaqs-answer">
      <p>Most patients notice reduced hair fall within 2–3 sessions and visible regrowth in 6–8 weeks.</p>
    </div>
  </div>
  
  <div className="blogfaqs-item">
    <div className="blogfaqs-question">
      Is this treatment suitable for women?
      <span className="blogfaqs-icon"></span>
    </div>
    <div className="blogfaqs-answer">
      <p>Absolutely! GrowHair Therapy works for both men and women with thinning hair or hormonal hair loss.</p>
    </div>
  </div>
  
  <div className="blogfaqs-item">
    <div className="blogfaqs-question">
      Does GrowHair Therapy have side effects?
      <span className="blogfaqs-icon"></span>
    </div>
    <div className="blogfaqs-answer">
      <p>No. It is a safe hair treatment that uses natural ingredients and nutrient infusions.</p>
    </div>
  </div>
  
  <div className="blogfaqs-item">
    <div className="blogfaqs-question">
      Can I combine it with other treatments like PRP or mesotherapy?
      <span className="blogfaqs-icon"></span>
    </div>
    <div className="blogfaqs-answer">
      <p>Yes, it complements other non-surgical hair regrowth methods for faster, more sustainable results.</p>
    </div>
  </div>
</div>

<div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Blog as PDF
            </button>
          </div>

   
   </>
  )
}

export default Growhair